import { moderationColors, sizes } from '@/utils'

import { ruleTags } from '@/components/rules/utils'
import tag from '@/components/tag'

function renderMessagePatternItem(h, item) {
  return h(
    'div',
    {
      class: 'faic fjcsb w--100'
    },
    [
      h('div', [ item.title ]),
      h(
        tag,
        {
          props: {
            label: this.getTranslate(`misc.moderation.${item.moderation}`),
            color: moderationColors[item.moderation],
            size: sizes.small
          }
        }
      )
    ]
  )
}

function resolveScopedSlots(h) {
  if (this.tag === ruleTags.messagePattern) {
    return {
      item: ({ item }) => {
        return renderMessagePatternItem.call(this, h, item)
      }
    }
  }

  return {}
}

export default function(h) {
  return h(
    this.$_component,
    {
      props: this.$_props,
      scopedSlots: resolveScopedSlots.call(this, h),
      on: this.$_on
    }
  )
}
